export default __webpack_public_path__ + "JP.7aa76d47c30ca59c7666.png";